import { styled } from '@mui/system'
//@ts-expect-error
import loadingAnimation from 'images/loading.gif'
import { type ReactElement, type ReactNode } from 'react'
export type LoadingProps = {
  $fullscreen: boolean | undefined
  children?: ReactNode
}
export default function Loading(props: LoadingProps): ReactElement<any, any> {
  return (
    <StyledDiv $fullscreen={props.$fullscreen}>
      <StyledImg src={loadingAnimation} />
      {props.children}
    </StyledDiv>
  )
}

const StyledDiv = styled('div')((props: LoadingProps) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  ...(props.$fullscreen && {
    position: 'absolute',
    top: 0,
    left: 0,
  }),
}))

const StyledImg = styled('img')({
  width: '20rem',
})
